/**
 * Check if the DOM has fully loaded and run a function
 * @param {function} callback
 */
const ready = (callback) => {
   if(document.readyState != 'loading') {
      callback();
   } else {
      document.addEventListener('DOMContentLoaded', callback);
   }
}

ready(() => {
   /**
    * Project Listing Tabs
   */
   const projectFilterAnchor = document.querySelectorAll('.project-tab-anchor');
   const projectFilterSelect = document.getElementById('project-cat-filter');
   const projectOutput = document.querySelector('.project-tab-listing');

   const anchorActiveClasses = ['font-semibold', 'text-black', 'cat-active'];
   const anchorInactiveClasses = ['font-regular', 'text-gray'];

   function makeAnchorActive(item) {
      item.classList.remove(...anchorInactiveClasses);
      item.classList.add(...anchorActiveClasses);
   }

   function removeAllActiveAnchors() {
      projectFilterAnchor.forEach(item => {
         item.classList.remove(...anchorActiveClasses);
         item.classList.add(...anchorInactiveClasses);
      });
   }

   function changeCategoryParam(param, value) {
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.set(param, value);
      return history.replaceState(null, null, "?"+queryParams.toString());
   }

   function removeParam(param) {
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.delete(param);
      return history.replaceState(null, null, "?"+queryParams.toString());
   }

   if ( projectFilterSelect ) {
      projectFilterAnchor.forEach(item => {
         item.addEventListener('click', () => {
            removeAllActiveAnchors();
            makeAnchorActive(item);
            
            // Change URL param
            const categorySlug = item.getAttribute('data-category-slug');
            removeParam('paginate');
            changeCategoryParam('category', categorySlug);
            const category = item.getAttribute('data-category');
   
            getProjectsAndOutput(category);
         })
      });
   
      projectFilterSelect.addEventListener('change', e => {
         const select = e.target;
         const category = select.value;
   
         const categorySlug = select.options[select.selectedIndex].getAttribute('data-slug');
         changeCategoryParam('category', categorySlug);
   
         getProjectsAndOutput(category);
      });

      initPaginationLinkEvents();
   }

   function getProjectsAndOutput(category, page = 1) {
      const posts_per_page = document.getElementById('posts_per_page').value;

      fetch(wp_ajax.ajax_url, {
         method: 'POST',
         body: new URLSearchParams({
            action: 'fetch_projects_by_cat',
            category,
            page,
            posts_per_page
         }),
      })
      .then(response => response.text())
      .then(result => {
         projectOutput.innerHTML = result;
         initPaginationLinkEvents();
      })
   }


   function initPaginationLinkEvents() {
      const paginationLinks = document.querySelectorAll('.project-page');
      const paginationActiveClasses = [...document.querySelector('.project-page.current').classList];
      const paginationInactiveClasses = [...document.querySelector('.project-page.other').classList];

      function makePaginationLinkActive(item) {
         item.classList.remove(...paginationInactiveClasses);
         item.classList.add(...paginationActiveClasses);
      }

      function removeAllActivePaginationLinks() {
         paginationLinks.forEach(item => {
            item.classList.remove(...paginationActiveClasses);
            item.classList.add(...paginationInactiveClasses);
         });
      }

      function getParameterByName(url, name) {
         var match = RegExp('[?&]' + name + '=([^&]*)').exec(url);
         return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
      }

      paginationLinks.forEach(item => {
         item.addEventListener('click', e => {
            e.preventDefault();

            removeAllActivePaginationLinks();
            makePaginationLinkActive(item);

            const page = parseInt(item.innerHTML);

            changeCategoryParam('paginate', page);

            const activeCat = document.querySelector('.cat-active');
            const category = activeCat.getAttribute('data-category');

            getProjectsAndOutput(category, page);
         })
      });
   }
});